import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { PiSpinnerLight, PiSpinnerBold } from 'react-icons/pi';

interface IProps {
  size?: number;
  color?: string;
  variant?: 'light' | 'bold';
}

const rotation = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Spinner = ({ size = 24, color = 'white', variant = 'light' }: IProps) => {
  return (
    <Box
      display="inline-flex"
      animation={`${rotation} 2s linear infinite`}
      color={color}
    >
      {variant === 'light' ? <PiSpinnerLight size={size} /> : <PiSpinnerBold size={size} />}
    </Box>
  );
};

export default Spinner;
